import styled from 'styled-components';

import { lighten, darken } from 'utils/colours';

import { Radio as AntdRadio } from 'antd';

const prefix = '.ant-radio-group';
const solidClass = `${prefix}-solid`;
const disabledButtonClass = `.ant-radio-button-wrapper-disabled`;
const checkedButtonClass = `.ant-radio-button-wrapper-checked`;

const RadioGroup = styled(AntdRadio.Group)`
    && {
        font-family: ${({ theme }) => theme.font.regular};
    }

    &${/* sc-selector */ solidClass}
        ${/* sc-selector */ checkedButtonClass}:not(
        ${/* sc-selector */ disabledButtonClass}
    ) {
        color: #fff;
        background: ${({ theme }) => theme.colour.primary};
        border-color: ${({ theme }) => theme.colour.primary};

        &:hover {
            color: #fff;
            background: ${({ theme }) => lighten(theme.colour.primary)};
            border-color: ${({ theme }) => lighten(theme.colour.primary)};
        }

        &:active {
            color: #fff;
            background: ${({ theme }) => darken(theme.colour.primary)};
            border-color: ${({ theme }) => darken(theme.colour.primary)};
        }
    }
`;
export default RadioGroup;
